module.exports = "/_next/static/images/regulatoryCompliance-f65e715a21c86f273902a5802fcd7337.webp";